import { get, cloneDeep, merge } from 'lodash-es';
import { translateColor } from './dataset-color-config-builder';

const HORIZONTAL_ANNOTATION_TEMPLATE = {
  type: 'line',
  borderColor: 'var(--fc-brand-blue-600)',
  borderWidth: 2,
  borderDash: [3, 2],
  label: {
    enabled: true,
    backgroundColor: 'var(--fc-brand-blue-600)',
    color: 'white',
    position: 'start',
    xPadding: 4,
    yPadding: 2,
    font: {
      size: 9,
      family: '"Poppins"'
    }
  }
};

const VERTICAL_ANNOTATION_TEMPLATE = {
  type: 'line',
  mode: 'vertical',
  borderColor: 'var(--fc-gray-500)',
  borderWidth: 1,
  borderDash: [3, 2],
  label: {
    enabled: true,
    backgroundColor: 'var(--fc-green-400)',
    color: 'white',
    position: 'end',
    yAdjust: 13,
    borderRadius: 50,
    padding: 0,
    yPadding: 0,
    xPadding: 6,
    height: 0,
    width: 50,
    content: ' ',
    font: {
      size: 1
    }
  }
};

export default (config, chartJSConfig, context) => {
  const { series: allSeries = [] } = config;
  const annotationSeries = allSeries.filter(series => ['KPI', 'CONST'].includes(series.seriesType));
  const annotations = annotationSeries.reduce((annotations, annotation, index) => {
    const data = get(annotation, 'aggregation.data[0]');
    const { style = {} } = annotation;
    let dataObject;
    // eslint-disable-next-line max-len
    const annotationTemplate = data.type === 'vertical' ? VERTICAL_ANNOTATION_TEMPLATE : HORIZONTAL_ANNOTATION_TEMPLATE;
    if (data.type === 'vertical') {
      dataObject = {
        xMin: data.xAxis,
        xMax: data.xAxis,
        yMin: data.yAxis
      };
    } else {
      if (!data || data.value === undefined || data.value === null) return;
      dataObject = {
        yMin: data.value,
        yMax: data.value,
        label: {
          content: (data.aggregationLabel || '').trim()
        }
      };
    }

    annotations[index] = translateAnnotationColors(
      merge(cloneDeep(annotationTemplate), dataObject, style), context);

    return annotations;
  }, {});

  const annotationsObject = { options: { plugins: { annotation: { annotations } } } };

  return merge(chartJSConfig, annotationsObject);
};

const translateAnnotationColors = (annotation, context) => {
  annotation.borderColor =
    translateColor(annotation.borderColor, context);
  if (annotation.label) {
    annotation.label.backgroundColor =
    `${translateColor(annotation.label.backgroundColor, context)}`;
    annotation.label.color =
    translateColor(annotation.label.color, context);
  }
  return annotation;
};
